module.exports = __webpack_public_path__ + "img/zhangyx.82d6d486.jpg";